import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessUserInterfaceProperty } from './process-user-interface-property';
export { ProcessUserInterfaceProperty };
import { processUserInterfacePropertySchema } from '@schemas/business-objects/process-user-interface-property';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';
import { ProcessUserInterfaceFormGroup } from './process-user-interface-form-group';

export class ProcessUserInterfacePropertyFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    isArray: SchemaFormControl;
    isInput: SchemaFormControl;
    isOutput: SchemaFormControl;
    required: SchemaFormControl;
    description: SchemaFormControl;
    sequence: SchemaFormControl;
    userInterfaceId: SchemaFormControl;
    userInterface: ProcessUserInterfaceFormGroup;
    typeId: SchemaFormControl;
    type: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessUserInterfaceProperty>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      processUserInterfacePropertySchema,
      ProcessUserInterfaceProperty,
      data,
      options,
    );
  }

  get object(): ProcessUserInterfaceProperty {
    return new ProcessUserInterfaceProperty(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'userInterface':
        return new ProcessUserInterfaceFormGroup();
      case 'type':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessUserInterfaceProperty[]> {
    return ProcessUserInterfaceProperty.find(filter);
  }

  static async findOne(
    filter?: any,
  ): Promise<ProcessUserInterfaceProperty | null> {
    return ProcessUserInterfaceProperty.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessUserInterfaceProperty> {
    return ProcessUserInterfaceProperty.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessUserInterfaceProperty>,
  ): Promise<ProcessUserInterfaceProperty> {
    return ProcessUserInterfaceProperty.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessUserInterfaceProperty>,
  ): Promise<ProcessUserInterfaceProperty> {
    return ProcessUserInterfaceProperty.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessUserInterfaceProperty.deleteById(id);
  }
}

export class ProcessUserInterfacePropertyFormArray extends PersistedFormArray {
  declare controls: ProcessUserInterfacePropertyFormGroup[];

  readonly entityName = 'ProcessUserInterfaceProperty' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(
      processUserInterfacePropertySchema,
      ProcessUserInterfaceProperty,
      options,
    );
  }

  protected override createItemGroup() {
    return new ProcessUserInterfacePropertyFormGroup();
  }

  get array(): ProcessUserInterfaceProperty[] {
    return this.controls.map(
      (group: ProcessUserInterfacePropertyFormGroup) => group.object,
    );
  }
}

export class ProcessUserInterfacePropertyPersistedArray extends PersistedArray<ProcessUserInterfaceProperty> {
  readonly entityName = 'ProcessUserInterfaceProperty' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessUserInterfaceProperty, options);
  }
}
